export const GET_BASE_PRICES_PER_KILOMETER = 'GET_BASE_PRICES_PER_KILOMETER';
export const GET_BASE_PRICE_PER_KILOMETER = 'GET_BASE_PRICE_PER_KILOMETER';
export const FLAG_GETTING_BASE_PRICES_PER_KILOMETER =
  'FLAG_GETTING_BASE_PRICES_PER_KILOMETER';
export const FLAG_BASE_PRICE_PER_KILOMETER_ACTIVITY =
  'FLAG_BASE_PRICE_PER_KILOMETER_ACTIVITY';
export const CLEAR_BASE_PRICE_PER_KILOMETER = 'CLEAR_BASE_PRICE_PER_KILOMETER';
export const CLEAR_BASE_PRICES_PER_KILOMETER =
  'CLEAR_BASE_PRICES_PER_KILOMETER';
